import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefaultReturnReadOnly"
import Responsive                                                from "react-responsive"
import ProductListItem from "components/Product/ProductListItem"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  render() {
    let { list, cart, products, onChange } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (<Fragment key={index}>
                <ProductListItem    place={"return"}
                                    history={this.props.history}
                                    index={index}
                                    key={index}
                                    product={product}/>
      </Fragment>
        
      )
    } )
    return (
      <Fragment>
        {rows}
      </Fragment>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductTableReturnReadOnly.js